import React from 'react';
import Modal from 'react-modal';
import PropTypes from 'prop-types';
import { Link, browserHistory } from 'react-router';
import { connect } from 'react-redux';
import {
    ROUTE_APP, ROUTE_SIGNIN, ROUTE_PROFILE_CURRENT
} from '../constants/routeconstants';
import { NotificationContainer, NotificationManager } from 'react-notifications';
import UserRoles from '../../../common/src/enums/UserRoles';
import GlobalErrorDialog from './misc/GlobalErrorDialog';
import * as AuthActions from '../actions/auth';
import * as UserActions from '../actions/user';
import * as AdminActions from '../actions/admin';
import * as RaceActions from '../actions/race';
import Footer from './misc/Footer';
import Avatar from '../components/reusable/image/Avatar';
import {calcDistance} from "../../../common/src/util/raceUtil";

const logo = typeof(window) === "undefined"
    ? null // <- don't require the image on the server (it will crash - no webpack).
    : require("!!file-loader!../../res/images/logo.png");  // file-loader = get image as path, url-loader = get image as "data:" + base64 encoded data.


class App extends React.Component {

    static contextTypes = {
        router: PropTypes.object.isRequired
    };

    static getId() {
        return ROUTE_APP;
    }
    
    static getAllowedRoles() {
        return []; // empty means allowed for all
    }

    constructor(props) {
        super(props);
        this.state = {
            logoSrc: null
        };
    }

    static keepAliveIntervalHandle = null;
    static checkImportsIntervalHandle = null;

    componentDidMount() {
        Modal.setAppElement('body'); // To prevent stupid warning turning up in the console when using modals
        const { dispatch } = this.props;
        dispatch(AuthActions.loginCheckSession()); // to make the frontend notice the user is logged in, in case the user reloads a page not requiring login (where requireAuth.js is not called) - can probably be done more elegantly (to save this extra request)
        App.keepAliveIntervalHandle = setInterval(() => {
            if (this.props.auth.isAuthenticated) {
                this.props.dispatch(AuthActions.setForceAuthRecheck(true));
            }
        }, 5 * 60 * 1000);
        App.checkImportsIntervalHandle = setInterval(() => {
            this.props.race.deviceImports.forEach((outstanding, id) => {
                dispatch(RaceActions.checkDeviceImport(id));
            });
        }, 5 * 1000);
        this.setState({
            logoSrc: logo
        });
    }

    componentWillUnmount() {
        if (App.keepAliveIntervalHandle !== null) clearInterval(App.keepAliveIntervalHandle);
        if (App.checkImportsIntervalHandle !== null) clearInterval(App.checkImportsIntervalHandle);
    }

    componentWillReceiveProps(nextProps) {
        if (!nextProps.admin.isBasicsRead && nextProps.auth.isAuthenticated) {
            this.props.dispatch(AdminActions.getBasics());
        }
    }

    render() {
        const headerLoggedInHtml = []; /*!this.props.auth.isAuthenticated ? [] : (
            <div className="header-user-info inline">
                <Link className="header-user-name" to={ROUTE_PROFILE_CURRENT} onClick={e => e.stopPropagation()}>
                    {this.props.auth.firstName + " " + this.props.auth.lastName}
                </Link>
                <div className="header-user-icon"><Avatar userId={this.props.auth.userId} size="small" /></div>
            </div>
        );*/
        const currentRole = typeof this.props.auth.currentRole === 'undefined' || typeof this.props.admin.userRoles === 'undefined' || this.props.auth.currentRole === null || this.props.admin.userRoles === null ? [] : this.props.admin.userRoles.filter(role => this.props.auth.currentRole === role.level && this.props.auth.currentEntity === role.id);
        const currentRoleTxt = currentRole.length === 0 ? null : currentRole[0].level === UserRoles.MAIN_ADMIN.id ? "DDB" : currentRole[0].id + " - " + currentRole[0].name;

        return (
            <div className={"document"}>
                <NotificationContainer/>
                <GlobalErrorDialog />


                    <div className="page-header">
                        <div className="logo inline">
                            <Link to="/">
                                <img src={this.state.logoSrc}/>
                            </Link>
                        </div>
                        <div className="navigation inline">
                            {/*<ul>
                                {this.props.auth.isAuthenticated ?
                                    <li className="nav-item"><h2><Link to={ROUTE_PROFILE_CURRENT} activeClassName="breadcrumb-active" onlyActiveOnIndex={true}>Profile</Link></h2></li>
                                    : ''}
                            </ul>*/}
                        </div>
                        {typeof(this.props.auth) === 'undefined' || typeof(this.props.auth.database) === 'undefined' || this.props.auth.database === 'standard' ? null : <div className="archive">
                            ARKIVDATABASE {this.props.auth.database}
                        </div>}
                        <div className="login inline">

                            <div className="header-user-info inline">
                                {/*<div className="header-user-icon"><Avatar userId={this.props.auth.userId} size="small" /></div>
                                <Link className="header-user-name" to={ROUTE_PROFILE_CURRENT} onClick={e => e.stopPropagation()}>
                                    {this.props.auth.firstName + " " + this.props.auth.lastName}
                                </Link>*/}
                                {this.props.auth.isAuthenticated ? this.props.auth.displayName : ''}
                                {currentRoleTxt === null ? '' : [
                                    <br/>,
                                    currentRoleTxt
                                ]}
                            </div>

                            <div className="header-login-link">
                                <i className="fa fa-lock" aria-hidden="true"/>
                                {(() => {
                                    if (!this.props.auth.isAuthenticated) {
                                        return (<Link className="inline btn-login" to={ROUTE_SIGNIN} activeClassName="breadcrumb-active" onlyActiveOnIndex={true} onClick={(event) => {
                                            event.preventDefault();
                                            window.location = '/login/drupal';
                                        }}>Log in</Link>);
                                    }
                                    else {
                                        return (<a className="inline btn-login" to="sign out" onClick={() => this.props.dispatch(AuthActions.logoutAndRedirect())} href="#">Log out</a>);
                                    }
                                })()}
                            </div>
                        </div>
                    </div>

                <div className="page-content">
                    {this.props.children}
                </div>
                <Footer/>
            </div>
        );
    }
}

const mapStateToPros = (state) => ({
    auth: {
        isAuthenticated : state.auth.isAuthenticated,
        isAuthenticating : state.auth.isAuthenticating,
        id: state.auth.id,
        displayName: state.auth.displayName,
        database: state.auth.database,
        currentRole: state.auth.currentRole,
        currentEntity: state.auth.currentEntity,
    },
    admin: {
        isBasicsRead: state.admin.isBasicsRead,
        userRoles: state.admin.userRoles,
    },
    race: {
        deviceImports: state.race.deviceImports
    }
});

export default connect(mapStateToPros)(App)



// WEBPACK FOOTER //
// ./src/client/src/components/app.js